import api from "@/libs/api";
import store from "@/store";

const initState = {
  interval_book_show: "",
  interval_data: "",
  interval_social:[],
  interval_group:[],
  interval_Allgroup:[]
};

const interval = {
  state: initState,
  mutations: {
    SET_INTERVAL_URL(state, url) {
      state.interval_book_show = url
    },
    SET_INTERVAL_DATA(state, sta) {
      state.interval_data = sta
    },
    //设置间隔分析指标
    SET_INTERVAL_SOCIAL(state,pay){
      state.interval_social = pay
    },
    //设置间隔分析分组
    SET_INTERVAL_GROUP(state,pay){
      state.interval_group = pay
    },
    SET_INTERVAL_ALLGROUP(state,pay){
      state.interval_Allgroup = pay
    }
  },
  getters: {},
  actions: {},
};

export default interval;


// WEBPACK FOOTER //
// ./src/store/modules/interval-analysis.js